import { render, staticRenderFns } from "./LastTicketsDetails.vue?vue&type=template&id=4e9e56bb&scoped=true"
import script from "./LastTicketsDetails.vue?vue&type=script&lang=js"
export * from "./LastTicketsDetails.vue?vue&type=script&lang=js"
import style0 from "./LastTicketsDetails.vue?vue&type=style&index=0&id=4e9e56bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9e56bb",
  null
  
)

export default component.exports